// Discord's and FACEIT's brand colors.
//
// These colors are pinned to sources outside this product. Do not adjust them
// for contrast, fold them into the theme, or reuse them as general-purpose
// accents. They change when upstream changes them.
//
// The other pinned colors live next to the code that draws them:
// - src/lib/match-viewer/: the 2D replay, deliberately game-accurate
// - src/screens/match/scoreboard/premier.ts: CS2 Premier tier colors
// - src/screens/match/scoreboard/rank-badge.ts: FACEIT level colors
// - src/screens/matches/collection/match/status/DefuserProgress.tsx and
//   wash-color.ts: the CS2 defuse HUD

export const discordColors = {
  blurple: '#5865f2',
  green: '#57f287',
  yellow: '#fee75c',
  fuchsia: '#eb459e',
  red: '#ed4245',
  white: '#ffffff',
  black: '#000000'
}

export const faceitColors = {
  primary: {
    orange: 'rgb(255, 85, 0)',
    white: 'rgb(235, 239, 243)',
    black: 'rgb(20, 22, 22)'
  }
}
